import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';

import * as Styled from './FooterEmailForm.styled';

/**
 * Component for email form that goes in the Footer.
 */

const FormSchema = Yup.object().shape({
  email: Yup.string()
    .email('Please enter a valid email address.')
    .required('Please enter a valid email address.')
});

const FooterEmailForm = ({
  handleSubmit,
  isAutoApplied,
  discountPercentage
}) => (
  <>
    <Styled.FormText>
      <p>
        Enter your email for {discountPercentage}% off
        {!isAutoApplied && <> your first order</>},
      </p>
      <p>plus the latest Bombas news.</p>
    </Styled.FormText>
    <Formik
      initialValues={{ email: '' }}
      validationSchema={FormSchema}
      onSubmit={(values, actions) => {
        handleSubmit(values, actions);
      }}
    >
      <Styled.EmailWrapper>
        <Styled.EmailForm data-testid="form">
          <Styled.TextInput
            data-testid="input"
            id="footerFormEmail"
            name="email"
            type="email"
            label="Email"
            autoComplete="email"
          />
          <Styled.EmailButton data-testid="email-button" type="submit">
            Sign Up
          </Styled.EmailButton>
        </Styled.EmailForm>
      </Styled.EmailWrapper>
    </Formik>
  </>
);

FooterEmailForm.propTypes = {
  /**
   * The submit function that executes when the signup button is clicked.
   */
  handleSubmit: PropTypes.func.isRequired,
  /**
   * If `true`, coupon is being auto applied.
   */
  isAutoApplied: PropTypes.bool,
  /**
   * Percentage off value of the discount
   */
  discountPercentage: PropTypes.number
};

FooterEmailForm.defaultProps = {
  isAutoApplied: false,
  discountPercentage: 20
};

export default FooterEmailForm;
